import type { ReactNode } from 'react'

import styles from './glassCard.module.scss'

export interface GlassCardProps {
  className?: string
  children?: ReactNode
}

export default function GlassCard({ className, children }: GlassCardProps) {
  return <div className={className ? `${styles.card} ${className}` : styles.card}>{children}</div>
}
